// import { FC } from 'react';
// import { Modal } from 'react-bootstrap';

// interface UserTableModalProps {
//     user: any;
//     onClose: () => void;
//     show: boolean;
// }

// export const RecyclerBankDetails: FC<UserTableModalProps> = ({ user, onClose, show }) => {
//     return (
//         <Modal
//             className='modal fade'
//             id='kt_modal_view_user'
//             data-backdrop='static'
//             tabIndex={-1}
//             role='dialog'
//             show={show}
//             centered
//             size="lg"
//         >
//             <div className="modal-content">
//                 <div className="modal-header pb-0 border-0 justify-content-end">
//                     <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}>
//                     </div>
//                 </div>

//                 <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
//                     <div className="text-center mb-13">
//                         <h1 className="mb-3">Bank Details</h1>
//                     </div>

//                     <div className="table-responsive">
//                         {/* <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
//                             <thead>
//                                 <tr className="fw-bold text-muted bg-light">
//                                     <th className="min-w-100px ps-4">Bank Name</th>
//                                     <th className="min-w-100px">Account No</th>
//                                     <th className="min-w-100px">IFSC Code</th>
//                                     <th className="min-w-100px">Account Holder Name</th>
//                                     <th className="min-w-100px">Cancel Cheque</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 <tr>
//                                     <td className="ps-4">
//                                         <span className="text-dark fw-semibold d-block fs-6">
//                                             {user?.bankDetails?.bankName || 'N/A'}
//                                         </span>
//                                     </td>
//                                     <td>
//                                         <span className="text-dark fw-semibold d-block fs-6">
//                                             {user?.bankDetails?.accountNo || 'N/A'}
//                                         </span>
//                                     </td>
//                                     <td>
//                                         <span className="text-dark fw-semibold d-block fs-6">
//                                             {user?.bankDetails?.ifscCode || 'N/A'}
//                                         </span>
//                                     </td>
//                                     <td>
//                                         <span className="text-dark fw-semibold d-block fs-6">
//                                             {user?.bankDetails?.accountName || 'N/A'}
//                                         </span>
//                                     </td>
//                                     <td>
//                                         <span className="text-dark fw-semibold d-block fs-6">
//                                             {user?.bankDetails?.images?.find(img => img.docType === "CANCEL_CHEQUE")?.docUrl ? (
//                                                 <a
//                                                     href={user.bankDetails.images.find(img => img.docType === "CANCEL_CHEQUE").docUrl}
//                                                     target="_blank"
//                                                     rel="noopener noreferrer"
//                                                 >
//                                                     <img
//                                                         src={user.bankDetails.images.find(img => img.docType === "CANCEL_CHEQUE").docUrl}
//                                                         alt="Cancel Cheque"
//                                                         style={{
//                                                             maxWidth: '100px',
//                                                             maxHeight: '100px',
//                                                             objectFit: 'contain'
//                                                         }}
//                                                     />
//                                                 </a>
//                                             ) : (
//                                                 'N/A'
//                                             )}
//                                         </span>
//                                     </td>
//                                 </tr>
//                             </tbody>
//                         </table> */}

//                         <div className="table-responsive">
//                             <table style={{
//                                 width: "100%",
//                                 borderCollapse: "collapse",
//                                 marginBottom: "20px",
//                                 border: "1px solid #ddd"
//                             }}>
//                                 <thead>
//                                     <tr>
//                                         <th colSpan={2} style={{
//                                             backgroundColor: "#BFD7ED",
//                                             color: "black",
//                                             fontWeight: "bold",
//                                             padding: "12px",
//                                             textAlign: "left",
//                                             border: "1px solid #ddd"
//                                         }}>
//                                             Bank Details
//                                         </th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     <tr>
//                                         <td style={{
//                                             width: "30%",
//                                             padding: "10px",
//                                             border: "1px solid #ddd",
//                                             fontWeight: "bold"
//                                         }}>
//                                             Bank Name
//                                         </td>
//                                         <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                             {user?.bankDetails?.bankName || 'N/A'}
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <td style={{
//                                             padding: "10px",
//                                             border: "1px solid #ddd",
//                                             fontWeight: "bold"
//                                         }}>
//                                             Account No
//                                         </td>
//                                         <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                             {user?.bankDetails?.accountNo || 'N/A'}
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <td style={{
//                                             padding: "10px",
//                                             border: "1px solid #ddd",
//                                             fontWeight: "bold"
//                                         }}>
//                                             IFSC Code
//                                         </td>
//                                         <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                             {user?.bankDetails?.ifscCode || 'N/A'}
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <td style={{
//                                             padding: "10px",
//                                             border: "1px solid #ddd",
//                                             fontWeight: "bold"
//                                         }}>
//                                             Account Holder Name
//                                         </td>
//                                         <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                             {user?.bankDetails?.accountName || 'N/A'}
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <td style={{
//                                             padding: "10px",
//                                             border: "1px solid #ddd",
//                                             fontWeight: "bold"
//                                         }}>
//                                             Cancel Cheque
//                                         </td>
//                                         <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                             {user?.bankDetails?.images?.find(img => img.docType === "CHEQUE_CERTIFICATE")?.docUrl ? (
//                                                 <a
//                                                     href={user.bankDetails.images.find(img => img.docType === "CHEQUE_CERTIFICATE").docUrl}
//                                                     target="_blank"
//                                                     rel="noopener noreferrer"
//                                                 >
//                                                     <img
//                                                         src={user.bankDetails.images.find(img => img.docType === "CHEQUE_CERTIFICATE").docUrl}
//                                                         alt="Cancel Cheque"
//                                                         style={{
//                                                             maxWidth: '100px',
//                                                             maxHeight: '100px',
//                                                             objectFit: 'contain'
//                                                         }}
//                                                     />
//                                                 </a>
//                                             ) : (
//                                                 'N/A'
//                                             )}
//                                         </td>
//                                     </tr>
//                                 </tbody>
//                             </table>
//                         </div>

//                     </div>

//                     <div className="modal-footer">
//                         <button
//                             type="button"
//                             className="btn btn-light"
//                             onClick={onClose}
//                         >
//                             Close
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         </Modal>
//     );
// };






















import axios from 'axios';
import { FC, useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
// import { useAuth } from '../../../../../../../_metronic/core';
import { useAuth } from '../../../../../auth';
import UploadImage from '../../../../../../../_metronic/helpers/components/ImageUpload';
import { useFormik } from 'formik';
import { useLocation } from 'react-router-dom';
import { successToast } from '../../../../../../../_metronic/helpers/components/Toaster';

interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}


interface IFSCDetails {
    BANK: string;
    BRANCH: string;
    ADDRESS: string;
    MICR: string;
    CITY: string;
    DISTRICT: string;
    STATE: string;
}

export const RecyclerBankDetails: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    const { currentUser } = useAuth();
    const isAdmin = (currentUser as any)?.role?.name === "ADMIN_CXO";
    const location = useLocation();
    const isRecyclerPath = location.pathname.includes('/apps/business/recycler');
    const isCollectionPointPath = location.pathname.includes('/apps/business/collection-point');

    const isRecyclerPathFinance = location.pathname.includes('/apps/finance/recycler');
    const isCollectionPointPathFinance = location.pathname.includes('/apps/finance/collection-point');

    // const canEdit = isAdmin && (isRecyclerPath || isCollectionPointPath);
    const canEdit = isAdmin && (isRecyclerPath || isRecyclerPathFinance || isCollectionPointPath || isCollectionPointPathFinance);

    const [ifscDetails, setIfscDetails] = useState<IFSCDetails | null>(null);
    const [ifscLoading, setIfscLoading] = useState(false);
    const fetchIfscDetails = async () => {
        if (!bankFields.ifscCode.trim()) {
            return;
        }

        setIfscLoading(true);
        try {
            const response = await fetch(`https://ifsc.razorpay.com/${bankFields.ifscCode}`);
            const data: IFSCDetails = await response.json();
            setIfscDetails(data);
            console.log('IFSC Details:', data);
        } catch (error) {
            console.error('Invalid IFSC code:', error);
            setIfscDetails(null);
        } finally {
            setIfscLoading(false);
        }
    };

    const [bankFields, setBankFields] = useState({
        bankName: '',
        accountNo: '',
        ifscCode: '',
        accountName: '',
        cancelChequeUrl: ''
    });

    const [originalFields, setOriginalFields] = useState({
        bankName: '',
        accountNo: '',
        ifscCode: '',
        accountName: '',
        cancelChequeUrl: ''
    });

    const [hasChanges, setHasChanges] = useState(false);
    const [isLoading, setIsLoading] = useState(false);


    const formik = useFormik({
        initialValues: {
            cancelCheque: bankFields.cancelChequeUrl
        },
        onSubmit: () => { },
        enableReinitialize: true
    });

    useEffect(() => {
        formik.setFieldValue('cancelCheque', bankFields.cancelChequeUrl);
    }, [bankFields.cancelChequeUrl]);

    // Initialize fields when user data changes
    useEffect(() => {
        if (user?.bankDetails) {
            const initialFields = {
                bankName: user.bankDetails.bankName || '',
                accountNo: user.bankDetails.accountNo || '',
                ifscCode: user.bankDetails.ifscCode || '',
                accountName: user.bankDetails.accountName || '',
                cancelChequeUrl: user.bankDetails.images?.[0]?.docUrl || ''
            };
            setBankFields(initialFields);
            setOriginalFields(initialFields);
        }
    }, [user]);

    // Check for changes
    // Check for changes whenever fields or formik values update
    useEffect(() => {
        const fieldsChanged = Object.keys(bankFields).some(
            key => bankFields[key as keyof typeof bankFields] !== originalFields[key as keyof typeof originalFields]
        );

        // Also check if image was uploaded
        const imageChanged = formik.values.cancelCheque !== (user?.bankDetails?.images?.[0]?.docUrl || '');

        setHasChanges(fieldsChanged || imageChanged);
    }, [bankFields, originalFields, formik.values.cancelCheque]);

    const handleFieldChange = (field: keyof typeof bankFields, value: string) => {
        setBankFields(prev => ({
            ...prev,
            [field]: value
        }));

        if (field === 'cancelChequeUrl') {
            formik.setFieldValue('cancelCheque', value);
        }
    };

    // const handleSave = async () => {
    //     if (!hasChanges || !user?.id) return;

    //     setIsLoading(true);
    //     try {
    //         const updatedPayload = {
    //             pickupPointStaffId: user.pickupPointStaffId,
    //             pickupPointStaffName: user.pickupPointStaffName,
    //             firstName: user.personalDetails?.name || "",
    //             email: user.personalDetails?.email || "",
    //             mobile: user.personalDetails?.mobile || "",
    //             userType: "PICKUP_POINT",
    //             countryCode: "91",
    //             franchiseId: user.franchiseId || "",
    //             status: "ACTIVE",
    //             kycDocument: [
    //                 {
    //                     docUrl: user.kycDocument?.[0]?.docUrl || "",
    //                     docNumber: user.kycDocument?.[0]?.docNumber || "",
    //                     docType: "CIN"
    //                 },
    //                 {
    //                     docUrl: user.kycDocument?.[1]?.docUrl || "",
    //                     docNumber: user.kycDocument?.[1]?.docNumber || "",
    //                     docType: "AADHAR"
    //                 },
    //                 {
    //                     docUrl: user.kycDocument?.[2]?.docUrl || "",
    //                     docNumber: user.kycDocument?.[2]?.docNumber || "",
    //                     docType: "GST_NUMBER"
    //                 },
    //                 {
    //                     docUrl: user.kycDocument?.[3]?.docUrl || "",
    //                     docNumber: user.kycDocument?.[3]?.docNumber || "",
    //                     docType: "PAN"
    //                 }
    //             ],
    //             companyDetails: {
    //                 name: user.companyDetails?.name || "",
    //                 companyId: user.companyDetails?.companyId || ""
    //             },
    //             address: [
    //                 {
    //                     addressType: "OFFICE_ADDRESS",
    //                     street: user.address?.[0]?.street || "",
    //                     city: user.address?.[0]?.city || "",
    //                     zipCode: user.address?.[0]?.zipCode || "",
    //                     country: user.address?.[0]?.country || "India",
    //                     state: user.address?.[0]?.state || ""
    //                 }
    //             ],
    //             bankDetails: {
    //                 bankName: bankFields.bankName,
    //                 accountNo: bankFields.accountNo,
    //                 ifscCode: bankFields.ifscCode,
    //                 accountName: bankFields.accountName,
    //                 images: [
    //                     {
    //                         docUrl: formik.values.cancelCheque, // Use formik value directly
    //                         docType: "CANCEL_CHEQUE"
    //                     }
    //                 ]
    //             }
    //         };

    //         const response = await fetch(`https://pfc-backend-api.asmglobal.co.in/v1/api/users/${user.id}/update`, {
    //             method: 'PUT',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //             body: JSON.stringify(updatedPayload)
    //         });

    //         if (!response.ok) {
    //             throw new Error('Failed to update user');
    //         }

    //         setOriginalFields(bankFields);
    //         setHasChanges(false);

    //     } catch (error) {
    //         console.error('Error updating user:', error);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };





    const handleSave = async () => {
        if (!hasChanges || !user?.id) return;
        setIsLoading(true);
        try {
            let updatedPayload;
            if (isRecyclerPath || isRecyclerPathFinance) {
                updatedPayload = {
                    firstName: user.personalDetails?.name || "",
                    email: user.personalDetails?.email || "",
                    mobile: user.personalDetails?.mobile || "",
                    userType: "RECYCLER",
                    countryCode: "91",
                    franchiseId: "",
                    status: "ACTIVE",
                    kycDocument: [
                        {
                            docUrl: user.kycDocument?.find(doc => doc.docType === 'AADHAR')?.docUrl || "",
                            docNumber: user.kycDocument?.find(doc => doc.docType === 'AADHAR')?.docNumber || "",
                            docType: "AADHAR"
                        },
                        {
                            docUrl: user.kycDocument?.find(doc => doc.docType === 'GST_CERTIFICATE')?.docUrl || "",
                            docNumber: user.kycDocument?.find(doc => doc.docType === 'GST_CERTIFICATE')?.docNumber || "",
                            docType: "GST_CERTIFICATE"
                        },
                        {
                            docUrl: user.kycDocument?.find(doc => doc.docType === 'PAN')?.docUrl || "",
                            docNumber: user.kycDocument?.find(doc => doc.docType === 'PAN')?.docNumber || "",
                            docType: "PAN"
                        },
                        {
                            docUrl: user.kycDocument?.find(doc => doc.docType === 'MSME_CERTIFICATE')?.docUrl || "",
                            docNumber: user.kycDocument?.find(doc => doc.docType === 'MSME_CERTIFICATE')?.docNumber || "",
                            docType: "MSME_CERTIFICATE"
                        }
                    ],
                    companyDetails: {
                        name: user.companyDetails?.name || "",
                        companyId: user.companyDetails?.companyId || "",
                    },
                    // address: [
                    //     {
                    //         addressType: "OFFICE_ADDRESS",
                    //         city: user.address?.city,
                    //         state: user.address?.state,
                    //         country: user.address?.country,
                    //         zipCode: user.address?.zipCode,
                    //         street: user.address?.street,
                    //         latitute: user.address?.[0]?.latitute || 0,
                    //         longitute: user.address?.[0]?.longitute || 0,
                    //     }
                    // ],
                    address: [
                        {
                            addressType: "OFFICE_ADDRESS",
                            city: user.address?.[0]?.city || "",
                            state: user.address?.[0]?.state || "",
                            country: user.address?.[0]?.country || "",
                            zipCode: user.address?.[0]?.zipCode || "",
                            street: user.address?.[0]?.street || "",
                            latitute: user.address?.[0]?.latitute || 0,
                            longitute: user.address?.[0]?.longitute || 0,
                        }
                    ],
                    bankDetails: {
                        bankName: bankFields.bankName,
                        accountNo: bankFields.accountNo,
                        ifscCode: bankFields.ifscCode,
                        accountName: bankFields.accountName,
                        images: [
                            {
                                docUrl: formik.values.cancelCheque,
                                docType: "CANCEL_CHEQUE"
                            }
                        ]
                    }
                };
            } else {
                // Collection point payload (existing)
                updatedPayload = {
                    pickupPointStaffId: user.pickupPointStaffId,
                    pickupPointStaffName: user.pickupPointStaffName,
                    firstName: user.personalDetails?.name || "",
                    email: user.personalDetails?.email || "",
                    mobile: user.personalDetails?.mobile || "",
                    userType: "PICKUP_POINT",
                    countryCode: "91",
                    franchiseId: user.franchiseId || "",
                    status: "ACTIVE",
                    kycDocument: [
                        {
                            docUrl: user.kycDocument?.[0]?.docUrl || "",
                            docNumber: user.kycDocument?.[0]?.docNumber || "",
                            docType: "CIN"
                        },
                        {
                            docUrl: user.kycDocument?.[1]?.docUrl || "",
                            docNumber: user.kycDocument?.[1]?.docNumber || "",
                            docType: "AADHAR"
                        },
                        {
                            docUrl: user.kycDocument?.[2]?.docUrl || "",
                            docNumber: user.kycDocument?.[2]?.docNumber || "",
                            docType: "GST_NUMBER"
                        },
                        {
                            docUrl: user.kycDocument?.[3]?.docUrl || "",
                            docNumber: user.kycDocument?.[3]?.docNumber || "",
                            docType: "PAN"
                        }
                    ],
                    companyDetails: {
                        name: user.companyDetails?.name || "",
                        companyId: user.companyDetails?.companyId || ""
                    },
                    address: [
                        {
                            addressType: "OFFICE_ADDRESS",
                            street: user.address?.[0]?.street || "",
                            city: user.address?.[0]?.city || "",
                            zipCode: user.address?.[0]?.zipCode || "",
                            country: user.address?.[0]?.country || "India",
                            state: user.address?.[0]?.state || ""
                        }
                    ],
                    bankDetails: {
                        bankName: bankFields.bankName,
                        accountNo: bankFields.accountNo,
                        ifscCode: bankFields.ifscCode,
                        accountName: bankFields.accountName,
                        images: [
                            {
                                docUrl: formik.values.cancelCheque,
                                docType: "CANCEL_CHEQUE"
                            }
                        ]
                    }
                };
            }

            const response = await fetch(`https://pfc-backend-api.asmglobal.co.in/v1/api/users/${user.id}/update`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updatedPayload)
            });

            if (!response.ok) {
                throw new Error('Failed to update user');
            }
            successToast('Modified');
            setOriginalFields({
                ...bankFields,
                cancelChequeUrl: formik.values.cancelCheque
            });
            setHasChanges(false);
        } catch (error) {
            console.error('Error updating user:', error);
        } finally {
            setIsLoading(false);
        }
    };



    const handleClose = () => {
        setBankFields(originalFields);
        setHasChanges(false);
        onClose();
    };

    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={handleClose}>
                        X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h1 className="mb-3">Bank Details</h1>
                    </div>

                    <div className="table-responsive">
                        <div className="table-responsive">
                            <table style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                marginBottom: "20px",
                                border: "1px solid #ddd"
                            }}>
                                <thead>
                                    <tr>
                                        <th colSpan={2} style={{
                                            backgroundColor: "#BFD7ED",
                                            color: "black",
                                            fontWeight: "bold",
                                            padding: "12px",
                                            textAlign: "left",
                                            border: "1px solid #ddd"
                                        }}>
                                            Bank Details
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{
                                            width: "30%",
                                            padding: "10px",
                                            border: "1px solid #ddd",
                                            fontWeight: "bold"
                                        }}>
                                            Bank Name
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {canEdit ? (
                                                <input
                                                    type="text"
                                                    value={bankFields.bankName}
                                                    onChange={(e) => handleFieldChange('bankName', e.target.value)}
                                                    style={{
                                                        width: "100%",
                                                        border: bankFields.bankName === '' ? "2px solid #fdb2c5" : "1px solid #ccc",
                                                        borderRadius: "4px",
                                                        padding: "8px",
                                                        fontSize: "14px"
                                                    }}
                                                    placeholder="Enter bank name"
                                                />
                                            ) : (
                                                <span>{bankFields.bankName || 'N/A'}</span>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{
                                            padding: "10px",
                                            border: "1px solid #ddd",
                                            fontWeight: "bold"
                                        }}>
                                            Account No
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {canEdit ? (
                                                <input
                                                    type="text"
                                                    value={bankFields.accountNo}
                                                    onChange={(e) => handleFieldChange('accountNo', e.target.value)}
                                                    style={{
                                                        width: "100%",
                                                        border: bankFields.accountNo === '' ? "2px solid #fdb2c5" : "1px solid #ccc",
                                                        borderRadius: "4px",
                                                        padding: "8px",
                                                        fontSize: "14px"
                                                    }}
                                                    placeholder="Enter account number"
                                                />
                                            ) : (
                                                <span>{bankFields.accountNo || 'N/A'}</span>
                                            )}
                                        </td>
                                    </tr>
                                    {/* <tr>
                                        <td style={{
                                            padding: "10px",
                                            border: "1px solid #ddd",
                                            fontWeight: "bold"
                                        }}>
                                            IFSC Code
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {canEdit ? (
                                                <input
                                                    type="text"
                                                    value={bankFields.ifscCode}
                                                    onChange={(e) => handleFieldChange('ifscCode', e.target.value)}
                                                    style={{
                                                        width: "100%",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "4px",
                                                        padding: "8px",
                                                        fontSize: "14px"
                                                    }}
                                                    placeholder="Enter IFSC code"
                                                />
                                            ) : (
                                                <span>{bankFields.ifscCode || 'N/A'}</span>
                                            )}
                                        </td>
                                    </tr> */}

                                    <tr>
                                        <td style={{
                                            padding: "10px",
                                            border: "1px solid #ddd",
                                            fontWeight: "bold"
                                        }}>
                                            IFSC Code
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {canEdit ? (
                                                <div>
                                                    <div style={{ display: "flex", gap: "8px" }}>
                                                        <input
                                                            type="text"
                                                            value={bankFields.ifscCode}
                                                            onChange={(e) => handleFieldChange('ifscCode', e.target.value)}
                                                            style={{
                                                                flex: 1,
                                                                border: bankFields.ifscCode === '' ? "2px solid #fdb2c5" : "1px solid #ccc",
                                                                borderRadius: "4px",
                                                                padding: "8px",
                                                                fontSize: "14px"
                                                            }}
                                                            placeholder="Enter IFSC code"
                                                        />
                                                        <button
                                                            type="button"
                                                            onClick={fetchIfscDetails}
                                                            disabled={ifscLoading}
                                                            style={{
                                                                padding: "8px 16px",
                                                                background: "#007bff",
                                                                color: "white",
                                                                border: "none",
                                                                borderRadius: "4px",
                                                                cursor: "pointer"
                                                            }}
                                                        >
                                                            {ifscLoading ? 'Loading...' : 'Search'}
                                                        </button>
                                                    </div>
                                                    {ifscDetails && (
                                                        <div style={{
                                                            marginTop: "10px",
                                                            padding: "10px",
                                                            background: "#f8f9fa",
                                                            borderRadius: "4px",
                                                            fontSize: "12px"
                                                        }}>
                                                            <div><strong>Bank:</strong> {ifscDetails.BANK}</div>
                                                            <div><strong>Branch:</strong> {ifscDetails.BRANCH}</div>
                                                            <div><strong>Address:</strong> {ifscDetails.ADDRESS}</div>
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <span>{bankFields.ifscCode || 'N/A'}</span>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{
                                            padding: "10px",
                                            border: "1px solid #ddd",
                                            fontWeight: "bold"
                                        }}>
                                            Account Holder Name
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {canEdit ? (
                                                <input
                                                    type="text"
                                                    value={bankFields.accountName}
                                                    onChange={(e) => handleFieldChange('accountName', e.target.value)}
                                                    style={{
                                                        width: "100%",
                                                        border: bankFields.accountName === '' ? "2px solid #fdb2c5" : "1px solid #ccc",
                                                        borderRadius: "4px",
                                                        padding: "8px",
                                                        fontSize: "14px"
                                                    }}
                                                    placeholder="Enter account holder name"
                                                />
                                            ) : (
                                                <span>{bankFields.accountName || 'N/A'}</span>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{
                                            padding: "10px",
                                            border: "1px solid #ddd",
                                            fontWeight: "bold"
                                        }}>
                                            Cancel Cheque
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {canEdit ? (
                                                <UploadImage name='cancelCheque' formik={formik} label='Upload Cancel Cheque' />
                                            ) : (
                                                bankFields.cancelChequeUrl ? (
                                                    <a
                                                        href={bankFields.cancelChequeUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <img
                                                            src={bankFields.cancelChequeUrl}
                                                            alt="Cancel Cheque"
                                                            style={{
                                                                maxWidth: '100px',
                                                                maxHeight: '100px',
                                                                objectFit: 'contain'
                                                            }}
                                                        />
                                                    </a>
                                                ) : 'N/A'
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={handleClose}
                        >
                            Close
                        </button>
                        {canEdit && (
                            <button
                                type="button"
                                className={`btn ${hasChanges ? 'btn-primary' : 'btn-secondary'}`}
                                onClick={handleSave}
                                disabled={!hasChanges || isLoading}
                                style={{
                                    marginLeft: "10px",
                                    opacity: hasChanges ? 1 : 0.6,
                                    cursor: hasChanges ? 'pointer' : 'not-allowed'
                                }}
                            >
                                {isLoading ? 'Saving...' : 'Save Changes'}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </Modal>
    );
};